import {Directive, ElementRef, forwardRef, Input, OnInit} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {Results} from '../../../core/results';
import {LaptopsService} from '../laptops.service';
import {Laptop} from './laptop';
declare var $: any;
@Directive({
  selector: '[appLaptop]',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => LaptopDirective),
    multi: true
  }]
})
export class LaptopDirective implements ControlValueAccessor, OnInit {

  @Input() private laptop: Laptop;
  @Input() private disabled = false;
  select2: any;

  constructor(private el: ElementRef, private service: LaptopsService) {
  }

  ngOnInit(): void {
    const that = this;
    this.select2 = $(this.el.nativeElement).select2({
      width: '100%',
      placeholder: 'Select laptop',
      allowClear: true,
      ajax: {
        transport: function(params, success, failure) {
          const page = 1;
          const perPage = 10;

          that.service.search(page, perPage, 'ASC', 'name', params.data.term).subscribe((ret: Results<Laptop>) => {
            success(ret);
          });

        },
        dataType: 'json',
        type: 'GET',
        processResults: function(data) {
          const arr = [];
          data.content.forEach(function(obj) {
            arr.push({
              id: JSON.stringify(obj),
              text: obj.brand,
            });
          });
          return {
            results: arr
          };
        }
      }
    });
    $(this.el.nativeElement).on('select2:select', function(e) {

      that.laptop = JSON.parse(e.params.data.id);
      that.propagateChange(that.laptop);

    });

    $(this.el.nativeElement).on('select2:unselect', function(e) {

      that.laptop = null;
      that.propagateChange(that.laptop);
    });


  }

  onTouched = () => {
  };

  propagateChange = (_: any) => {
  };

  writeValue(laptop: Laptop): void {

    this.laptop = laptop;
    this.propagateChange(this.laptop);
    const that = this;
    if (this.laptop !== undefined && this.laptop !== null) {
      const option = new Option(laptop.brand, JSON.stringify(laptop), true, true);
      that.select2.append(option);
      that.select2.trigger('change');
    }

  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  get value(): any {
    return this.laptop;
  }

  set value(v: any) {
    if (v !== this.laptop) {
      this.laptop = v;
      this.propagateChange(v);
    }
  }


}
